import { useEffect, useState } from "react";
import { useAuthStore } from "@/stores/authStore";
import { notificationService } from "@/lib/services/notifications";
import type { AppNotification } from "@/types";

export function useNotifications() {
  const uid = useAuthStore((s) => s.user?.uid);
  const [items, setItems] = useState<AppNotification[]>([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setItems([]);
      setUnread(0);
      setLoading(false);
      return;
    }
    setLoading(true);
    const unsubInbox = notificationService.subscribeInbox(uid, (list) => {
      setItems(list);
      setLoading(false);
    });
    const unsubUnread = notificationService.subscribeUnreadCount(
      uid,
      setUnread,
    );
    return () => {
      unsubInbox();
      unsubUnread();
    };
  }, [uid]);

  return {
    items,
    unread,
    loading,
    markRead: notificationService.markRead,
    markAllRead: () =>
      uid ? notificationService.markAllRead(uid) : Promise.resolve(0),
  };
}
